import { render } from "./Survey.vue?vue&type=template&id=4b4618b8&scoped=true&bindings={\"handleSubmit\":\"options\",\"checkEmail\":\"options\",\"loaded\":\"data\",\"showLoading\":\"data\",\"showAllRequired\":\"data\",\"surveydata\":\"data\",\"email\":\"data\",\"institution\":\"data\",\"name\":\"data\",\"emailValid\":\"data\",\"submitted\":\"data\",\"categoryData\":\"data\"}"
import script from "./Survey.vue?vue&type=script&lang=js"
export * from "./Survey.vue?vue&type=script&lang=js"

import "./Survey.vue?vue&type=style&index=0&id=4b4618b8&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4b4618b8"

export default script